import { render, staticRenderFns } from "./socialAccounts.vue?vue&type=template&id=d5d68a82&scoped=true&"
import script from "./socialAccounts.vue?vue&type=script&lang=js&"
export * from "./socialAccounts.vue?vue&type=script&lang=js&"
import style0 from "./socialAccounts.vue?vue&type=style&index=0&id=d5d68a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d68a82",
  null
  
)

export default component.exports